import { Alert, Button } from "antd";
import { useTranslation } from "react-i18next";

interface QueryErrorAlertProps {
  className?: string;
  "data-testid"?: string;
  description: string;
  onRetry?: () => void;
  retryLoading?: boolean;
  title?: string;
}

export const QueryErrorAlert = ({
  description,
  title,
  onRetry,
  retryLoading = false,
  className,
  "data-testid": testId = "query-error-alert",
}: QueryErrorAlertProps) => {
  const { t } = useTranslation(["common"]);

  return (
    <Alert
      type="error"
      className={className}
      title={title ?? t("common:errors.generic")}
      description={description}
      showIcon
      data-testid={testId}
      action={
        onRetry ? (
          <Button
            size="small"
            type="default"
            loading={retryLoading}
            onClick={onRetry}
          >
            {t("common:components.buttons.retry")}
          </Button>
        ) : undefined
      }
    />
  );
};
